import { Link } from "@inertiajs/react";
import reviewCarIcon from "../../../assets/images/review_car_white.svg";
import ShareExperienceBlock from "../../../pages/Home/components/ShareExperienceBlock";

const Footer = ({
  showShareExperienceBlock = true,
}: {
  showShareExperienceBlock?: boolean;
}) => {
  return (
    <>
      {showShareExperienceBlock && <ShareExperienceBlock />}
      <div className="bg-primary text-white p-3 py-8 flex flex-col justify-between">
        <div className="container mx-auto flex flex-col gap-4 lg:gap-0 lg:flex-row items-center justify-between">
          <img src={reviewCarIcon} className="w-[150px]" alt="logo" />
          <div className="flex gap-4">
            <Link
              href="/contest_conditions"
              className="underline hover:no-underline"
            >
              Règles du concours
            </Link>
            <Link
              href="/legal_mention"
              className="underline hover:no-underline"
            >
              Mentions légales
            </Link>
            <a
              href="#"
              className="underline hover:no-underline"
              onClick={(e) => {
                e.preventDefault();
                (window as any).openAxeptioCookies?.();
              }}
            >
              Cookies
            </a>
            <span className="flex justify-end">
              Copyright © 2025 • Review Car
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
